import apiUrl from '../../../constants'
import axios from 'axios'
import iptrackerdetails from '../../../iptrackerdetails'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'hubuseraccess',
  components: {
    VueElementLoading,
    Multiselect
  },
  data: function() {
    return {
      userid: '',
      isProjectloader : false,
      isOverride : false,
      displayForm:'',
      show: '',
      emptype: '',
      invaliduserflag: '',
      MobileNumber: '',
      useridarray:[],
      listProjectData: [],
      projectid: '',
      successMsg:'',
      hubvalidate: true,
      isHubWise : false,
      hubid : '',
      hubServiceCenterList: [],
      form: {
        projectidwiserole: [],
        projectidwisemultirole: [],
        values: [],
        value: [],
        projectidchk: [],
        is_active: [],
        proSel:'',
        projectstatus:'',
      },
    }
  },

  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.iptrackData = userdetail
    let iptrck= await iptrackerdetails.checkUserIPV2(this.iptrackData,'Register Users',this.$route.path);
    //console.log(iptrck);
    if(iptrck){
      this.$router.push('/');
    }

    this.localusermailid = userdetail.email;
    this.show = false;
    this.getHubServiceCenterData()
  },
  methods: {
    closeSuccessMsg(){
      this.successMsg = false;
      this.displayForm = false;
    },
    resetForm() {
      this.userid = '';
      this.emptype = '';
      this.listProjectData = [];
      this.hubid = ''
    },
    validateRole(projectid, event) {
      if (event.target.checked) {
        this.$validator.attach('projectroleid' + projectid, 'required');
        this.$validator.attach('projectstatus' + projectid, 'required');
        document.getElementById('projectroleid' + projectid).disabled = false;
        //document.getElementById('projectmultiroleid' + projectid).disabled = false;
        document.getElementById('projectstatus' + projectid).disabled = false;
      } else {
        this.$validator.detach('projectroleid' + projectid);
        this.form.projectidwiserole[projectid] = '';
        this.form.is_active[projectid] = '';
        this.listHubsData = [];
        document.getElementById('projectroleid' + projectid).disabled = true;
        document.getElementById('projectstatus' + projectid).disabled = true;
      }
      var checkedCount = $('input[name=projectid]:checkbox:checked').length;
      if (checkedCount > 0) {
         this.form.proSel = projectid;
      } else {
         this.form.proSel ="";
      }
    },
    removeValidation(projectroleid) {
      var e = document.getElementById(projectroleid).value;
      if (e != "") {
          this.$validator.detach(projectroleid);
        } else {
          this.$validator.attach(projectroleid, 'required');
        }
    },
    removeStatusValidation(projectstatus) {
      var e = document.getElementById(projectstatus).value;
      if (e != "") {
        this.$validator.detach(projectstatus);
      } else {
        this.$validator.attach(projectstatus, 'required');
      }
    },

    onSubmit: function(event) {
      if (this.isHubWise) {
        if (this.hubid) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.saveUserProjectAccess();
            }
          }).catch(() => {
            console.log('errors exist', this.errors)
          });
        } else {
          this.hubvalidate = false
        }
      } else {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.saveUserProjectAccess();
          }
        }).catch(() => {
          console.log('errors exist', this.errors)
        });
      }
    },
    closeRegistration() {
      this.$router.push('/admindashboard');
    },
    bindroleid(projectid) {
      var res = '';
      var selectedProjects = this.form.projectidchk;
      selectedProjects.forEach(function(k, v) {
        if (v == projectid) {
          res = k.roleid;
        }
      });
      return res;
    },
    bindmultiroleid(projectid) {
      var res = '';
      var selectedProjects = this.form.projectidchk;
      selectedProjects.forEach(function(k, v) {
        if (v == projectid) {
          res = k.roleid;
        }
      });
      return res;
    },

    setname(projectid) {
      return 'projectroleid' + projectid;
    },
    setrolename(projectid){
      return 'projectmultiroleid'+projectid;
    },
    setStatus(projectid) {
      return 'projectstatus' + projectid;
    },
    saveUserProjectAccess() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      let tempArr=[];

      let useridarray = this.userid.split(/[,]+/);
      let multiroles=[]
       this.form.projectidchk.map((obj,key) =>{
         if(obj && this.form.projectidwiserole[key]!=""){

          let multirole = this.form.projectidwisemultirole[key];
          let defaultrole = this.form.projectidwiserole[key];
          let finalmultirole=[];
          Object.keys(multirole).map(function(key, index) {
            if(multirole[key].roleid != defaultrole){
              finalmultirole.push(multirole[key]);
            }
          });
           tempArr.push({
             "projectid":key,
             "roleid":this.form.projectidwiserole[key],
             "multiroles":finalmultirole == "" ? multiroles : finalmultirole,
             "is_active":this.form.is_active[key]
            })
          }
      });
        this.input = ({
          userid: useridarray,
          modifiedby : this.localusermailid,
          utype: (this.isHubWise) ? 2 : this.emptype,
          projectroleid: tempArr,
          isOverride : this.isOverride,
          isHubWise : this.isHubWise,
          hubs : this.hubid.id
        })
      this.show = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'setUserProjectRoleDetails',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then( result => {
            this.show = false;
            // this.$alertify.success(result.data.msg);
            this.successMsg = result.data.msg
            this.displayForm = false;
            //this.$router.push('/admindashboard');
        }, error => {
          this.show = false;
          this.$alertify.error(error.message);
          console.error(error)
        })
    },
    resetUseridWiseForm(){
      this.listProjectData = []
      this.emptype = ''
      this.userid = ''
    },
    getHubServiceCenterData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      this.input = {}
      axios({
          method: 'GET',
          url: apiUrl.api_url + 'external/gethubservicecenterlist',
          data: this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          var data = [];
          result.data.hubs.data.forEach(function (hubData) {
            data.push({
              id:hubData.HubID,
              label:hubData.HubName + "("+hubData.HubID+")"
            });
          });
          this.hubServiceCenterList = data;
        }, error => {
          console.error(error)
        })
    },
    fetchUsersFromHub(){
      console.log("CODE STARTS HERE");

    },
    getProjectData() {
      this.listProjectData = [];
      this.form.projectidchk = [];
      this.form.projectidwiserole = [];
      this.form.projectidwisemultirole = [];
      this.form.is_active = [];
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      if (this.isHubWise) {
        this.hubvalidate = true
        this.input = ({
          usertype : 2
        })
      } else {
        this.input = ({
          usertype: this.emptype
        });
      }
      this.isProjectloader = true
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getTypeWiseProjectRoleList',
          data: this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listProjectData = result.data;
          let projects = result.data;
          projects.forEach((projectitem, key) => {
            this.form.projectidwiserole[projectitem.project.projectid] = "";
            this.form.projectidwisemultirole[projectitem.project.projectid] = "";
            this.form.is_active[projectitem.project.projectid] = "";
          });
          this.isProjectloader = false
        }, error => {
          console.error(error)
        })
    }
  }
}

Validator.extend('verify_userids', {
  getMessage: field => "Invalid User Id's.",
  validate: value => {
      var userIDs = $("#userid").val();
      let userid=userIDs.split(/[,]+/);
      let flag=0;
      for (let i = 0; i < userid.length; i++) {
        if(isNaN(userid[i])){
          flag=1;
        }
      }
      if(flag==1){
        return false;
      }else{
        return true;
      }
  }
});

Validator.extend('max_userids', {
  getMessage: field => "maximum 200 userid you can enter",
  validate: value => {
    var userids = $("#userid").val();
    let useridarray = userids.split(/[,]+/);
    if (useridarray.length > 200) {
      return false;
    } else {
      return true;
    }
  }
});



// WEBPACK FOOTER //
// ./src/views/components/hubuseraccess/hubuseraccess.component.js